import { ActionsCell, Cell, Row, SkeletonCheckbox, SkeletonText } from '@tlx/atlas';

export const SkeletonRows = ({
    numberOfColumns,
    numberOfActions,
    checkbox,
}: {
    numberOfColumns: number;
    numberOfActions: number;
    checkbox?: boolean;
}) =>
    Array.from({ length: 10 }).map((_, index) => (
        <Row key={index} className={`skeleton-row skeleton-row-${index}`}>
            {checkbox && (
                <Cell className="atl-p-8 atl-pl-12">
                    <SkeletonCheckbox />
                </Cell>
            )}
            {Array.from({ length: numberOfColumns }).map((_, index) => (
                <Cell key={index} className="atl-p-8">
                    <SkeletonText className={'atl-w-full'} />
                </Cell>
            ))}
            {numberOfActions > 0 && (
                <ActionsCell>
                    <div className={'atl-flex atl-gap-24'}>
                        {Array.from({ length: numberOfActions }).map((_, index) => (
                            <SkeletonCheckbox key={index} />
                        ))}
                    </div>
                </ActionsCell>
            )}
        </Row>
    ));
